<script setup lang="ts">
import type { Priceable } from "#shared/types/pricing";

const props = defineProps<{ priceable?: Priceable; singularPrice?: boolean }>();

const auth = useAuthorizeStore();

const route = useRoute();

const login = useLogin(() => route.path);

const prices = usePrices(() => props.priceable, "recurring");

const data = computed(() => {
  if (prices.value === "NOT_APPLICABLE") {
    return undefined;
  }

  const exVatPrice = prices.value?.actual?.exVat;

  let basePrice: number | undefined;
  if (props.priceable) {
    const { withoutVat } = taxConverter(props.priceable);
    basePrice = withoutVat(props.priceable.prices.default);
  }

  return {
    isMetered: (prices.value?.actual?.isMetered && (exVatPrice !== basePrice || !auth.loggedIn)) ?? false,
    exVatPrice,
    savings: basePrice && exVatPrice ? basePrice - exVatPrice : 0,
  };
});
</script>

<template>
  <abbr v-if="data?.isMetered && !auth.loggedIn">
    <span class="align-top" aria-hidden="true">*</span>Vi tilbyr avtalepriser og kvantumsrabatter til skoler på produktet. <button class="underline" @click="login('feide')">Logg inn med Feide</button> for å se skolens pris per elev.
  </abbr>
  <p v-else-if="data?.isMetered && data?.savings">
    Skolen har avtalepris hos Aschehoug på {{ norwegianPrice(data.exVatPrice) }} pr. elev, dere får {{ norwegianPrice(data.savings) }} i kvantumsrabatt.
  </p>
  <p v-else-if="!data?.isMetered">
    Prisen{{ singularPrice ? '' : 'e' }} gjelder for {{ auth.isConsumer ? "privatpersoner" : "bedrifter" }}. <button class="underline" @click="login(auth.isConsumer ? 'feide' : 'vipps')">
      Logg inn med {{ auth.isConsumer ? "Feide" : "Vipps" }}
    </button> for å bestille som
    {{ auth.isConsumer ? "bedrift" : "privatperson" }}.
  </p>
</template>
